export enum ModeType {
    Create = 'create',
    Edit = 'edit',
}
